import addIndex from 'ramda/es/addIndex'
import map from 'ramda/es/map'

export default addIndex(map)
